import { render, staticRenderFns } from "./ShippingCostTableMobile.vue?vue&type=template&id=352f84ed&scoped=true"
import script from "./ShippingCostTableMobile.vue?vue&type=script&lang=js"
export * from "./ShippingCostTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f84ed",
  null
  
)

export default component.exports